export const DIFFICULTY_COLORS = {
  common: "#8892b0",
  rare: "#45b7d1",
  epic: "#9333ea",
  legendary: "#ffd700",
} as const;

export const DIFFICULTY_XP_MULTIPLIER = {
  common: 1,
  rare: 4,
  epic: 8,
  legendary: 20,
} as const;

export const LEVEL_XP_THRESHOLDS = [
  0, 100, 250, 500, 900, 1400, 2000, 2800, 3800, 5000,
];

export function xpToLevel(xp: number): number {
  let level = 1;
  for (let i = 0; i < LEVEL_XP_THRESHOLDS.length; i++) {
    if (xp >= LEVEL_XP_THRESHOLDS[i]) level = i + 1;
  }
  return Math.min(level, LEVEL_XP_THRESHOLDS.length);
}

export function xpProgressInLevel(xp: number): { current: number; needed: number } {
  const level = xpToLevel(xp) - 1;
  const start = LEVEL_XP_THRESHOLDS[level] ?? 0;
  const end = LEVEL_XP_THRESHOLDS[level + 1] ?? LEVEL_XP_THRESHOLDS[LEVEL_XP_THRESHOLDS.length - 1];
  return { current: xp - start, needed: end - start };
}
